import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { apiClient } from '../../utils/apiClient';

// レイアウトはルート側で `AppLayout` を適用するため、このページでは使わない

// 事務画面（Figma: 988:13585）
// 現時点ではスタティックなモックで構成し、スタイルは既存ユーティリティクラスで近似再現
// 将来、API連携・検索/フィルタ機能を実装予定
const OfficePage: React.FC = () => {
  // Figmaの構造に合わせた2カラム（メニュー + コンテンツ）
  return (
    <div className="flex gap-[20px] items-start w-full p-[30px]">
      <section className="flex-1 flex flex-col gap-[50px] px-[60px] py-[40px]">
        {/* お知らせ帯 */}
        <div className="w-full">
          <div className="border-4 border-[#db3d23] px-[30px] py-[15px]">
            <div className="flex items-center gap-[20px]">
              <span className="text-[14px] text-[#db3d23]">NEW</span>
              <span className="text-[14px] text-black">2025.08.20</span>
              <span className="text-[14px] text-black flex-1">
                鈴木太郎さんから紹介状作成依頼が届きました
              </span>
              <div className="flex items-center gap-2 text-[#db3d23]">
                <span className="text-[14px]">患者様詳細</span>
              </div>
            </div>
          </div>
        </div>

        <div className="flex w-full gap-[40px]">
          {/* 左リスト：予約一覧（オンライン診断） */}
          <div className="flex-1 flex flex-col gap-[20px]">
            <h2 className="text-[24px] font-semibold text-[#1e1e1e] tracking-[-0.48px]">
              予約一覧（オンライン診断）
            </h2>
            {/* フィルタ帯（ダミー） */}
            <div className="flex items-center gap-[10px]">
              <div className="flex items-center gap-2 border border-[#d9d9d9] rounded-full px-4 py-2 w-[300px]">
                <span className="text-[16px] text-[#b3b3b3] flex-1">Value</span>
                <div className="w-4 h-4 rounded-full bg-[#d9d9d9]" />
              </div>
              <div className="flex items-center gap-2 border border-[#d9d9d9] rounded-full px-4 py-3 h-[32px] w-[136px]">
                <span className="text-[14px]">ステータス</span>
                <div className="w-4 h-4 rounded-full bg-[#d9d9d9]" />
              </div>
              <div className="flex items-center gap-2">
                <div className="border border-[#c8c8c8] rounded-[30px] px-[15px] py-[10px] text-[12px]">
                  前の50件
                </div>
                <div className="text-[14px]">100-150</div>
                <div className="border border-[#c8c8c8] rounded-[30px] px-[15px] py-[10px] text-[12px]">
                  次の50件
                </div>
              </div>
            </div>
            {/* 予約行（API連携） */}
            <ReservationList />
          </div>

          {/* 右リスト：来院履歴 */}
          <div className="flex-1 flex flex-col gap-[20px]">
            <h2 className="text-[24px] font-semibold text-black tracking-[-0.48px]">来院履歴</h2>
            {/* フィルタ帯（ダミー） */}
            <div className="flex items-center gap-[10px] pt-[20px] px-[20px]">
              <div className="w-[31px]" />
              <div className="w-[80px] text-[12px]">診療日</div>
              <div className="w-[50px] text-[12px] text-[#c8c8c8]">時間</div>
              <div className="w-[130px] text-[12px] text-[#c8c8c8]">患者様氏名</div>
            </div>
            <div className="border border-[rgba(0,0,0,0.2)] px-[20px] py-[15px] bg-white flex items-center gap-[10px]">
              <span className="text-[14px] w-[80px]">2025.08.01</span>
              <span className="text-[14px] w-[50px]">19:00</span>
              <span className="text-[14px] flex-1">鈴木 太郎</span>
              <div className="flex items-center gap-2 text-[#db3d23]">
                <span className="text-[14px]">診療後手続き</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OfficePage;

// 予約一覧（オンライン診断）をAPIから取得して表示するシンプルなリスト
// 既存の予約エンドポイントに準拠（フロントの他ページと同一クライアントを使用）
interface AppointmentItem {
  id: string;
  patientNameKanji?: string;
  patientNameKana?: string;
  companyName?: string;
  slotStart: string; // ISO
}

// APIレスポンスの推定型（バックエンド DTO に合わせた最低限）
interface AppointmentApiResponse {
  id?: string;
  patientId?: string;
  doctorId?: string;
  slotStart?: string;
  slotEnd?: string;
  status?: string;
  // 画面表示向けの拡張（あれば利用）
  patientNameKanji?: string;
  patientName?: string;
  patientNameKana?: string;
  companyName?: string;
  company?: string;
  start?: string;
  appointmentStart?: string;
}

const formatDate = (iso: string) => {
  const d = new Date(iso);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}.${m}.${day}`;
};

const formatTime = (iso: string) => {
  const d = new Date(iso);
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  return `${hh}:${mm}`;
};

function ReservationList() {
  const [items, setItems] = useState<AppointmentItem[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [busyId, setBusyId] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        // API仕様に合わせてクエリパラメータを付与（doctorId, start, end）
        const doctorId = 'doc-0001';
        // 期間固定（日本時間で 2025/01/01 00:00:00 ～ 2026/12/31 23:59:59）
        // APIはUTCのInstantを受けるため、JST(+09:00)をUTCへ変換して送信
        // JST 2025-01-01 00:00:00 => UTC 2024-12-31 15:00:00
        // JST 2026-12-31 23:59:59 => UTC 2026-12-31 14:59:59
        const start = new Date(Date.UTC(2024, 11, 31, 15, 0, 0));
        const end = new Date(Date.UTC(2026, 11, 31, 14, 59, 59));

        const qs = new URLSearchParams({
          doctorId,
          start: start.toISOString(),
          end: end.toISOString(),
        }).toString();

        const data = await apiClient(`/api/v1/appointments?${qs}`);
        if (!mounted) return;
        // 期待形への正規化（最低限のフィールドを抽出）
        const normalized: AppointmentItem[] = Array.isArray(data)
          ? data.map((a: AppointmentApiResponse) => ({
              id: String(a.id ?? `${a.slotStart}-${a.patientNameKanji ?? ''}`),
              patientNameKanji: a.patientNameKanji ?? a.patientName ?? '',
              patientNameKana: a.patientNameKana ?? '',
              companyName: a.companyName ?? a.company ?? '',
              slotStart: a.slotStart ?? a.start ?? a.appointmentStart ?? '',
            }))
          : [];
        setItems(normalized);
      } catch (e: unknown) {
        if (!mounted) return;
        setError(e instanceof Error ? e.message : '予約一覧の取得に失敗しました');
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  if (error) {
    return (
      <div className="border border-[#c8c8c8] px-[20px] py-[12px] bg-white">
        <span className="text-[14px] text-red-600">{error}</span>
      </div>
    );
  }

  if (!items) {
    // ローディング用プレースホルダ（Figmaとテイストを揃えた行）
    return (
      <>
        {Array.from({ length: 3 }).map((_, i) => (
          <div
            key={i}
            className="border border-[#c8c8c8] px-[20px] py-[12px] bg-white flex items-center gap-[10px]"
          >
            <span className="text-[14px] w-[80px] text-[#c8c8c8]">----</span>
            <span className="text-[14px] w-[50px] text-[#c8c8c8]">--:--</span>
            <span className="text-[14px] w-[120px] text-[#c8c8c8]">読み込み中...</span>
            <span className="text-[14px] flex-1 text-[#c8c8c8]">読み込み中...</span>
          </div>
        ))}
      </>
    );
  }

  if (items.length === 0) {
    return (
      <div className="border border-[#c8c8c8] px-[20px] py-[12px] bg-white">
        <span className="text-[14px] text-[#757575]">予約はありません。</span>
      </div>
    );
  }

  return (
    <>
      {items.map((item, idx) => (
        <div
          key={item.id}
          role="button"
          aria-label={`予約詳細へ移動 ${formatDate(item.slotStart)} ${formatTime(item.slotStart)}`}
          onClick={async () => {
            try {
              setBusyId(item.id);
              // 予約に紐づくミーティングを作成/取得してからオンライン会議ページへ遷移
              const res = await apiClient(`/api/v1/meetings/${item.id}`, { method: 'POST' });
              const meetingId = res?.id ?? res?.meetingId ?? item.id;
              navigate(`/online-meeting/${meetingId}`);
            } catch (e) {
              // 失敗時は予約IDでそのまま遷移（バックエンド側で対応）
              navigate(`/online-meeting/${item.id}`);
            } finally {
              setBusyId(null);
            }
          }}
          className={
            (idx === 0 ? 'border-4 border-black' : 'border border-[#c8c8c8]') +
            ' px-[20px] py-[12px] bg-white flex items-center gap-[10px] cursor-pointer hover:brightness-95' +
            (busyId === item.id ? ' opacity-60 pointer-events-none' : '')
          }
        >
          <span className="text-[14px] w-[80px]">{formatDate(item.slotStart)}</span>
          <span className="text-[14px] w-[50px]">{formatTime(item.slotStart)}</span>
          <span className="text-[14px] w-[120px]">{item.patientNameKanji || '—'}</span>
          <span className="text-[14px] flex-1 whitespace-nowrap overflow-hidden text-ellipsis">
            {item.companyName || '—'}
          </span>
        </div>
      ))}
    </>
  );
}
